/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflicts_TitleInputs */

const cs_ebr_conflicts_title = /** @type {(inputs: Ebr_Conflicts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konflikty`)
};

const en_ebr_conflicts_title = /** @type {(inputs: Ebr_Conflicts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conflicts`)
};

/**
* | output |
* | --- |
* | "Conflicts" |
*
* @param {Ebr_Conflicts_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflicts_title = /** @type {((inputs?: Ebr_Conflicts_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflicts_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflicts_title(inputs)
	return cs_ebr_conflicts_title(inputs)
});